 const ProjectData = [
    {
        id: 1,
        title: 'Iron Man Mark Armors Info scraper (Web scrapping)',
        tools: ['Python','Beautifulsoup','flask'],
        desc: 'This app was created to scrape the information about Iron man Mark armors from Fandom Website and showed them in all together in a website. Anyone can click the armor names in the website and can see all the information related to that armor.',
        link: 'https://github.com/MahbubHossainFaisal/IronMan-Mark-Armors-Scraper',
        image: require('../../assets/projectImages/jail.jpg')
    },
    {
        id: 2,
        title: 'Games Reviews Scraper (Web scrapping)',
        tools: ['Python','Beautifulsoup','flask'],
        desc: 'This app was created to scrape only the user reviews of PC games from a website and show them all together in a single website. User can search any game in his mind and can see the user reviwes.',
        link: 'https://github.com/MahbubHossainFaisal/Games-user-reviews-scraper',
        image: require('../../assets/projectImages/College.png')
    },
    {
        id: 3,
        title: 'Relational Database Management System (FreeCodeCamp)',
        tools: ['Postgre SQL','Shell'],
        desc: 'These are some Database projects which I have done while completing the Database Management System Course offered by FreeCodeCamp',
        link: 'https://github.com/MahbubHossainFaisal/FreeCodeCamp_Relational_Database_Management_System',
        image: require('../../assets/projectImages/Confusion.jpg')
    },
    {
        id: 4,
        title: 'Power BI projects',
        tools: ['PowerBI'],
        desc: 'These are some data visualization and analytics projects done with PowerBI',
        link: 'https://github.com/MahbubHossainFaisal/PowerBI',
        image: require('../../assets/projectImages/expenseTracker.jpg')
    },
    {
        id: 5,
        title: 'Laptop Price Predictor',
        tools: ['Python','Numpy','Pandas','matplotlib','seaborn','Sklearn'],
        desc: 'This is a Machine learning project which predict the price of a laptop after providing all the desired features of the laptop',
        link: 'https://github.com/MahbubHossainFaisal/Laptop_Price_Predictor',
        image: require('../../assets/projectImages/FoodOrder.jpg')
    },
    {
        id: 6,
        title: 'Tic Tac Toe',
        tools: ['CSS','React Hooks'],
        desc: 'A tic tac toe game by react',
        link: 'https://github.com/MahbubHossainFaisal/React-Tic-Tac-Toe',
        image: require('../../assets/projectImages/tictactoe.png')
    },
    {
        id: 7,
        title: 'Notes app',
        tools: ['NodeJS'],
        desc: 'This is an app where user can store,delete,update and read their notes.It is a console based program.',
        link: 'https://github.com/MahbubHossainFaisal/Notes-app',
        image: require('../../assets/projectImages/Notes.png')

    },
    {
        id: 8,
        title: 'Weather app',
        tools: ['NodeJS','Express','weathermap api'],
        desc: 'This is an app which can show the weather status of any place in the world',
        link: 'https://github.com/MahbubHossainFaisal/Weather-app',
        image: require('../../assets/projectImages/Weather.png')
    },
    {
        id: 9,
        title: 'Guess The Number',
        tools: ['JavaScript'],
        desc: 'This is a game made with JavaScript,mostly cover the concept of dom manipulation',
        link: 'https://github.com/MahbubHossainFaisal/Guess-My-Number',
        image: require('../../assets/projectImages/GuessMyNumber.jpg')
    },
    {
        id: 10,
        title: '2D animation and games',
        tools: ['P5JS'],
        desc: 'Some animations and 2D games created with the p5js library of JavaScript',
        link: 'https://github.com/MahbubHossainFaisal/P5JS',
        image: require('../../assets/projectImages/P5JS.png')
    },
    {
        id:11,
        title: 'DSA Tutor',
        tools: ['React', 'Firebasee'],
        desc: 'This is a tutorial app where user can create account, login, can watch tutorial related to DSA, Can give quiz and also check his marks distribution',
        link: 'https://github.com/MahbubHossainFaisal/DSA-Tutor',
        image: require('../../assets/projectImages/dsa.jpg')
    },
    {
        id:12,
        title: 'BankQuick',
        tools: ['React'],
        desc: 'This is banking app where user can send, recieve, request loan and withdraw money from the bank with many additional features',
        link: 'https://github.com/MahbubHossainFaisal/BankQuick',
        image: require('../../assets/projectImages/bank.jpg')
    },
    {
        id:13,
        title: 'E-Hut',
        tools: ['React','ASP.NET','Bootstrap'],
        desc: 'This is an e-commerce application built during our Software Project Course. I have worked in the frontend part',
        link: 'https://github.com/MahbubHossainFaisal/e-hut_frontend',
        image: require('../../assets/projectImages/ecommerce.png')
    }

]

export default ProjectData